export const LIVRAISON_ENREGISTRER = 'livraison/LIVRAISON_ENREGISTRER';
export const LIVRAISON_LISTER = 'livraison/LIVRAISON_LISTER';
export const LIVRAISON_SUPPRIMER = 'livraison/LIVRAISON_SUPPRIMER';
